import React, { useState } from 'react';
import { View, Text, ScrollView, Image, Toast } from '../app-components';
import { validateEmail, validateMobile, getErrorString } from '../Lib/helpers';
import { invoke } from '../AppServices';
import {
  AutoSuggestInput,
  TextInput,
} from '../app-components/input-components/Editors';
import { FormField } from '../app-components/form/field';
import { Form } from '../app-components/form/Form';
import { appraiseLogo } from '../images';
import SignupStyle from './SignupStyle';
import { Button } from '@applane/react-core-components';
import { h10_Montessart } from '../theme/fonts';

export default () => {
  const { SignupLeftSide } = SignupStyle;

  return ({ navigation }) => {
    const [checked, setChecked] = useState(false);
    const [checkErrorMessage, setCheckErrorMessage] = useState('');
    const [passwordMatchErorrMessage, setPasswordMatchErrorMessage] =
      useState('');

    const handleCheck = () => {
      setChecked(!checked);
    };

    const handleSubmit = async ({ data }) => {
      data.previouslyOnKyc = 'none';
      if (data.password === data.confirmPassword) {
        setPasswordMatchErrorMessage('');
      } else {
        setPasswordMatchErrorMessage(
          'Password and confirm password do not match.',
        );
      }

      if (!checked) {
        setCheckErrorMessage(
          'Please read our terms and conditions before signing up',
        );
      } else {
        setCheckErrorMessage('');
      }

      if (checked && data.password === data.confirmPassword) {
        try {
          const stockProvideResult = await invoke({
            id: 'dealerSignup',
            paramValue: data,
          });

          if (stockProvideResult) {
            Toast.show({
              message: 'Success',
              description: 'Your account has been successfully created.',
              type: 'success',
              position: 'top',
              direction: 'right',
              duration: 3000,
            });
            window.location.replace('/');
          }
        } catch (e) {
          Toast.show({
            message: 'Error',
            description: `${getErrorString(e)}`,
            type: 'error',
            position: 'top',
            direction: 'right',
          });
        }
      }
    };

    return (
      <ScrollView>
        {/* left side started */}
        <View
          style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
          <View style={SignupLeftSide}>
            <Button
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigation.replace('/');
              }}>
              <Image source={appraiseLogo} style={{ width: '170px' }} />
            </Button>
            <Text
              style={{
                fontFamily: 'Poppins',
                fontStyle: 'italic',
                fontSize: '18px',
                color: '#fafafa',
              }}>
              {/*hehe*/}
            </Text>
            <View style={{ display: 'flex', gap: '30px' }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  fontSize: '36px',
                  color: '#FAFAFA',
                }}>
                Sign in!
              </Text>
              <View
                style={{ border: '1px solid #FAFAFA', width: '68.5px' }}></View>
              <Text
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  color: '#FAFAFA',
                  lineHeight: '27px',
                }}>
                Welcome to fully automated appraisals! Sign in and set your
                parameters in the setup page and let the software work it's
                magic!
              </Text>
            </View>
          </View>
          {/* left side over */}
          <View style={SignupStyle.rightSide}>
            {/* right side started */}
            <View>
              <Form
                validations={{
                  email: ({ data }) => validateEmail(data.email),
                  phonenumber: ({ data }) => validateMobile(data.phonenumber),
                }}
                mandatory={{
                  username: 'Name is mandatory',
                  password: 'Password is mandatory',
                  dms: 'DMS is mandatory',
                  vmpp: 'VMPP is mandatory',
                  address: 'Company address is mandatory',
                  email: 'Email is mandatory',
                  phonenumber: 'Number is mandatory',
                }}
                required={{
                  username: 1,
                  password: 1,
                  dms: 1,
                  vmpp: 1,
                  email: 1,
                  address: 1,
                  phonenumber: 1,
                }}
                navigation={navigation}
                scrollable={false}
                onSubmit={handleSubmit}
                bodyContainerStyle={SignupStyle.formBox}>
                <SignupFormNew
                  checkErrorMessage={checkErrorMessage}
                  passwordMatchErorrMessage={passwordMatchErorrMessage}
                  handleCheck={handleCheck}
                  navigation={navigation}
                />
              </Form>
            </View>
            {/* right side over */}
          </View>
        </View>
      </ScrollView>
    );
  };
};

const SignupFormNew = ({
  form_context: formContext,
  checkErrorMessage,
  passwordMatchErorrMessage,

  handleCheck,
  navigation,
}) => {
  const { handleSubmit } = formContext;

  return (
    <View id="main1" style={SignupStyle.boxToHoldAllFields}>
      <View id="main2" style={SignupStyle.boxToHoldSignupTitle}>
        Sign Up
      </View>
      <View id="main3" style={SignupStyle.boxToHoldRowFields}>
        <View id="main4" style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="dms"
            label="DMS"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <AutoSuggestInput options={['CDK Global']} />
          </FormField>
        </View>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="vmpp"
            label="VMPP"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <AutoSuggestInput options={['Galves']} />
          </FormField>
        </View>
      </View>

      <View style={SignupStyle.boxToHoldRowFields}>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="username"
            label="NAME"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput allowWhiteSpaces={true} />
          </FormField>
        </View>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="email"
            label="EMAIL"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput />
          </FormField>
        </View>
      </View>

      <View style={SignupStyle.boxToHoldRowFields}>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="address"
            label="COMPANY ADDRESS"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput allowWhiteSpaces={true} />
          </FormField>
        </View>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="phonenumber"
            label="PHONE NUMBER"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput />
          </FormField>
        </View>
      </View>
      <View style={SignupStyle.boxToHoldRowFields}>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="password"
            label="PASSWORD"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput inputProps={{ type: 'password' }} />
          </FormField>
        </View>
        <View style={SignupStyle.boxToHoldIndividualField}>
          <FormField
            style={SignupStyle.formFieldProperties}
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            field="confirmPassword"
            label="CONFIRM PASSWORD"
            variant="filled"
            onSubmitEditing={handleSubmit}>
            <TextInput inputProps={{ type: 'password' }} />
          </FormField>
        </View>
      </View>

      <View style={SignupStyle.boxToShowPasswordError}>
        {passwordMatchErorrMessage}
      </View>
      <View style={SignupStyle.boxToHoldCheckbox}>
        <Text>
          <input
            type="checkbox"
            onChange={handleCheck}
            style={{ cursor: 'pointer' }}
          />
        </Text>
        <Text style={SignupStyle.checkboxTextProperties}>
          By creating an account you agree to the{' '}
          <Button
            style={SignupStyle.termsOfUseButtonProperties}
            onClick={() => {
              navigation.replace('termsAndConditions');
            }}>
            {' '}
            terms of use
          </Button>{' '}
          and our{' '}
          <Button
            style={SignupStyle.privacyPolicyButtonProperties}
            onClick={() => {
              navigation.replace('termsAndConditions');
            }}>
            {' '}
            privacy policy.
          </Button>
        </Text>
      </View>

      <View style={SignupStyle.boxToShowCheckError}>{checkErrorMessage}</View>

      <View style={SignupStyle.boxToHoldCreateAccountButton}>
        <Button
          style={SignupStyle.createAccountButtonProperties}
          onClick={handleSubmit}>
          Create Account
        </Button>
      </View>

      <View style={SignupStyle.alreadyBox}>
        <View style={{ paddingRight: 10 }}>Already have an account?</View>

        <Button
          style={SignupStyle.alreadyLoginButtonProperties}
          onClick={() => {
            navigation.replace('/');
          }}>
          Log in
        </Button>
      </View>
    </View>
  );
};
